import { render } from "./NoticeLayerPopup.vue?vue&type=template&id=52af67d9&scoped=true"
import script from "./NoticeLayerPopup.vue?vue&type=script&lang=js"
export * from "./NoticeLayerPopup.vue?vue&type=script&lang=js"

import "./NoticeLayerPopup.vue?vue&type=style&index=0&id=52af67d9&scoped=true&lang=css"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52af67d9"]])

export default __exports__